import { useContext, useMemo } from 'react';
import { ApplicationContext } from '../../components/application-provider/application-context';
import { AppContextInterface } from '../../types';

export function useActiveWeb3React(): AppContextInterface {
  const context = useContext(ApplicationContext);
  return useMemo(() => context || {}, [context]);
}
